<div class="container">

    <p>Logbooks of completed deliveries may be edited and resubmitted as many times as desired up to one week after the original submission date. For EM trips, this edit window is extended to 90 days after the original submission date.</p>
    <p>All fields may be edited and additional sets can be attached from the current pending set list. Sets part of a prior submission will appear 
        and be included in the resubmission but cannot be edited.</p>

        <h2 class="help-header">Editing an existing logbook</h2>
        <ul>
            <li>When viewing a completed delivery tap/click the button in the top right to change the delivery from 'view' to 'edit' mode.</li>
            <img [src]="getImgs[0]"
                 class="help-img help-container"
                (click)="showImage(getImgs[0])" />

            <li>Edits made to a delivery will be saved and persist unless they are explicitly discarded before resubmitting.</li>

            <li>While there is an edited logbook with unsubmitted edits, you will see an indication on the Completed Deliveries section of the menu.</li>
            <img [src]="getImgs[1]"
                class="help-img help-container"
                (click)="showImage(getImgs[1])" />

            <li>The delivery currently being edited will also be indicated on the delivery list page.</li>
            <img [src]="getImgs[2]"
                class="help-img help-container"
                 (click)="showImage(getImgs[2])" />

        </ul>

        <h2 class="help-header">Discarding edits</h2>
        <ul>
            <li>Edits made to a delivery may be discarded, reverting the delivery to its original unedited state. 
                The same button to enable edits will change to a 'discard edits' button.</li>
            <img [src]="getImgs[3]"
                class="help-img help-container"
                 (click)="showImage(getImgs[3])" />

            <li>Tapping/Clicking this button will discard all edits. As all edits will be permanently lost, you will be prompted twice to ensure you really want to do this.</li>
            <img [src]="getImgs[4]"
                class="help-img help-container"
                 (click)="showImage(getImgs[4])" />
        </ul>


        <h2 class="help-header">Submitting edits</h2>
        <ul>
            <li>Once the delivery has been edited to satisfaction it can be submitted just as you would with a new delivery.</li>
            <li>Tap the submit button in the bottom right and confirm your submission on the review screen. You will receive an email summary as you would with a new submission.</li>
            <img [src]="getImgs[5]"
                class="help-img help-container"
                 (click)="showImage(getImgs[5])" />
        </ul>

</div>
